import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const Step11Shared = () => (
  <ol>
    <li>
      <FormattedMessage {...messages.other1} />
    </li>
    <li>
      <FormattedMessage {...messages.other2} />
    </li>
    <li>
      <FormattedMessage {...messages.other3} />
    </li>
  </ol>);
export default Step11Shared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step11/components/Step11Shared.js